import {
  Box,
  IconButton,
  LinearProgress,
  Snackbar,
  Typography,
} from "@mui/material";
import { Check, Cross, Download, X, CircleAlert } from "lucide-react";
import "./SnackBar.scss";
import { useEffect, useState } from "react";

export default function CustomSnackbar({
  open,
  onClose,
  mode,
  menu,
}: {
  open: boolean;
  onClose: () => void;
  mode: string;
  menu: string;
}) {
  const [progress, setProgress] = useState(0);

  const snackbarSubtitle = () => {
    switch (menu) {
      case "units":
        return (
          <Typography>Se actualizó la información de la unidad</Typography>
        );
      case "areas":
        return <Typography>Se actualizó la información del área</Typography>;
      case "categories":
        return (
          <Typography>Se actualizó la información de la categoría</Typography>
        );
      case "added-success-case":
        return (
          <Typography>Se actualizó la información de la idea</Typography>
        );
    }
  };

  const snackbarTitle1 = () => {
    switch (menu) {
      case "units":
        return <Typography>Unidad</Typography>;
      case "areas":
        return <Typography>Área</Typography>;
      case "categories":
        return <Typography>Categoría</Typography>;
      case "added-success-case":
        return (
          <Typography>Idea marcada como Caso de éxito</Typography>
        );
      case "deleted-success-case":
        return (
          <Typography>Idea eliminada de los Casos de éxito</Typography>
        );
    }
  };

  const snackbarTitle2 = () => {
    switch (mode) {
      case "add":
        return <Typography>añadida con éxito</Typography>;
      case "edit":
        return <Typography>editada con éxito</Typography>;
      case "delete":
        return <Typography>eliminada con éxito</Typography>;
      case "added-succes-case":
      case "deleted-success-case":
        return <></>;
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    const duration = 5000;
    const interval = 50;
    const increment = 100 / (duration / interval);

    setProgress(0);

    timer = setInterval(() => {
      setProgress((prev) => {
        const next = prev + increment;
        if (next >= 100) {
          clearInterval(timer);
          onClose();
          return 100;
        }
        return next;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [open, mode, onClose]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      onClose={onClose}
    >
      <Box className="snackbar">
        <Box className="snackbar__content">
          <Check size={25} style={{ color: "#608C18" }} />
          <Box className="snackbar__content__text">
            <Typography className="snackbar__content__text-title">
              {snackbarTitle1()}&nbsp;{snackbarTitle2()}
            </Typography>
            <Typography className="snackbar__content__text-subtitle">
              {snackbarSubtitle()}
            </Typography>
          </Box>
          <X size={30} className="snackbar__close-icon" onClick={onClose} />
        </Box>
        <LinearProgress
          className="snackbar__linear"
          variant="determinate"
          value={progress}
        />
      </Box>
    </Snackbar>
  );
}
